import { gql } from "@apollo/client";

export const CREATE_FEEDBACK = gql`
  mutation CreateFeedback($data: createFeedbackDto!) {
    createFeedback(data: $data) {
      id
      callSid
      rating
      reason
      description
      createdAt
      updatedAt
      createdBy
    }
  }
`;

export const GET_FEEDBACK = gql`
  query GetFeedback($id: String!) {
    getFeedback(id: $id) {
      id
      callSid
      rating
      reason
      description
      createdAt
      updatedAt
      createdBy
    }
  }
`;

export const GET_FEEDBACKS = gql`
  query GetFeedbacks($createdBy: String, $rating: Float) {
    getFeedbacks(createdBy: $createdBy, rating: $rating) {
      id
      callSid
      rating
      reason
      description
      createdAt
      updatedAt
      createdBy
    }
  }
`;

export const UPDATE_FEEDBACK = gql`
  mutation UpdateFeedback($data: updateFeedbackDto!) {
    updateFeedback(data: $data) {
      id
      callSid
      rating
      reason
      description
      createdAt
      updatedAt
      createdBy
    }
  }
`;